// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-grey2: #f5f5f5;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;

  /* Technology-specific colors */
  --react-color: #61DAFB;
  --aws-color: #efefef;
  --python-color: #3776AB;
  --nodejs-color: #339933;
  --webflow-color: #4353FF;
  --reactnative-color: #02B3E4;
  --javascript-color: #F7DF1E;
  --solidity-color: #363636;
  --ethereum-color: #4461f0;
}

/* Page Load Animation */
@keyframes pageLoad {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Component Enter Animation */
@keyframes componentEnter {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


.Technologies-section {
  height: 30vh;
  text-align: center;
  overflow: hidden;
  opacity: 0;
  transform: translateY(50px);
  transition: all 1s ease-out;
  animation: pageLoad 1s ease-out;
}

.Technologies-section.is-visible {
  opacity: 1;
  transform: translateY(0);
  animation: componentEnter 1s ease-out forwards;
}

.Technologies-title-box h1 {
  font-size: 2rem;
  color: var(--primary-black2);
  opacity: 0;
  transform: translateY(20px);
  transition: all 1s ease-out 0.8s;
}

.Technologies-section.is-visible .Technologies-title-box h1 {
  opacity: 1;
  transform: translateY(0);
}

.Technologies-container-scroll {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  opacity: 0;
  transform: translateY(50px);
  transition: all 1s ease-out 0.7s;
}

.Technologies-container-scroll.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.Technologies-container {
  display: flex;
  gap: 30px;
  height: 80%;
  width: max-content;
  align-items: center;
  animation: scroll 90s linear infinite;
  will-change: transform;
}

/* Pause animation on hover */
.Technologies-container-scroll:hover .Technologies-container {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.Technologies-card {
  background-color: var(--primary-white);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  width: 250px;
  flex-shrink: 0;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.Technologies-card:hover {
  transform: translateY(-10px) scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.Technologies-card-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Technologies-card-img img {
  width: 50px;
  height: 50px;
  padding: 8px;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

/* Unique background colors for each technology */
.Technologies-card:nth-child(1) .Technologies-card-img img,
.Technologies-card:nth-child(10) .Technologies-card-img img {
  background-color: var(--react-color);
}

.Technologies-card:nth-child(2) .Technologies-card-img img,
.Technologies-card:nth-child(11) .Technologies-card-img img {
  background-color: var(--aws-color);
}

.Technologies-card:nth-child(3) .Technologies-card-img img,
.Technologies-card:nth-child(12) .Technologies-card-img img {
  background-color: var(--python-color);
}

.Technologies-card:nth-child(4) .Technologies-card-img img,
.Technologies-card:nth-child(13) .Technologies-card-img img {
  background-color: var(--nodejs-color);
}

.Technologies-card:nth-child(5) .Technologies-card-img img,
.Technologies-card:nth-child(14) .Technologies-card-img img {
  background-color: var(--webflow-color);
}

.Technologies-card:nth-child(6) .Technologies-card-img img,
.Technologies-card:nth-child(15) .Technologies-card-img img {
  background-color: var(--reactnative-color);
}

.Technologies-card:nth-child(7) .Technologies-card-img img,
.Technologies-card:nth-child(16) .Technologies-card-img img {
  background-color: var(--javascript-color);
}

.Technologies-card:nth-child(8) .Technologies-card-img img,
.Technologies-card:nth-child(17) .Technologies-card-img img {
  background-color: var(--solidity-color);
}

.Technologies-card:nth-child(9) .Technologies-card-img img,
.Technologies-card:nth-child(18) .Technologies-card-img img {
  background-color: var(--ethereum-color);
}

.Technologies-card:hover .Technologies-card-img img {
  transform: rotate(360deg);
}

.Technologies-card-title {
  font-size: 1.2rem;
  color: var(--primary-black2);
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .Technologies-card {
    width: 200px;
  }
 
  .Technologies-title-box h1 {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Technologies/Technologies.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;;EAEzB,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;wBAEsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-grey2: #f5f5f5;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n\n  /* Technology-specific colors */\n  --react-color: #61DAFB;\n  --aws-color: #efefef;\n  --python-color: #3776AB;\n  --nodejs-color: #339933;\n  --webflow-color: #4353FF;\n  --reactnative-color: #02B3E4;\n  --javascript-color: #F7DF1E;\n  --solidity-color: #363636;\n  --ethereum-color: #4461f0;\n}\n\n/* Page Load Animation */\n@keyframes pageLoad {\n  0% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Component Enter Animation */\n@keyframes componentEnter {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n.Technologies-section {\n  height: 30vh;\n  text-align: center;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(50px);\n  transition: all 1s ease-out;\n  animation: pageLoad 1s ease-out;\n}\n\n.Technologies-section.is-visible {\n  opacity: 1;\n  transform: translateY(0);\n  animation: componentEnter 1s ease-out forwards;\n}\n\n.Technologies-title-box h1 {\n  font-size: 2rem;\n  color: var(--primary-black2);\n  opacity: 0;\n  transform: translateY(20px);\n  transition: all 1s ease-out 0.8s;\n}\n\n.Technologies-section.is-visible .Technologies-title-box h1 {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.Technologies-container-scroll {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  opacity: 0;\n  transform: translateY(50px);\n  transition: all 1s ease-out 0.7s;\n}\n\n.Technologies-container-scroll.is-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.Technologies-container {\n  display: flex;\n  gap: 30px;\n  height: 80%;\n  width: max-content;\n  align-items: center;\n  animation: scroll 90s linear infinite;\n  will-change: transform;\n}\n\n/* Pause animation on hover */\n.Technologies-container-scroll:hover .Technologies-container {\n  animation-play-state: paused;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.Technologies-card {\n  background-color: var(--primary-white);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 20px;\n  width: 250px;\n  flex-shrink: 0;\n  gap: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.Technologies-card:hover {\n  transform: translateY(-10px) scale(1.05);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.Technologies-card-img {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Technologies-card-img img {\n  width: 50px;\n  height: 50px;\n  padding: 8px;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n/* Unique background colors for each technology */\n.Technologies-card:nth-child(1) .Technologies-card-img img,\n.Technologies-card:nth-child(10) .Technologies-card-img img {\n  background-color: var(--react-color);\n}\n\n.Technologies-card:nth-child(2) .Technologies-card-img img,\n.Technologies-card:nth-child(11) .Technologies-card-img img {\n  background-color: var(--aws-color);\n}\n\n.Technologies-card:nth-child(3) .Technologies-card-img img,\n.Technologies-card:nth-child(12) .Technologies-card-img img {\n  background-color: var(--python-color);\n}\n\n.Technologies-card:nth-child(4) .Technologies-card-img img,\n.Technologies-card:nth-child(13) .Technologies-card-img img {\n  background-color: var(--nodejs-color);\n}\n\n.Technologies-card:nth-child(5) .Technologies-card-img img,\n.Technologies-card:nth-child(14) .Technologies-card-img img {\n  background-color: var(--webflow-color);\n}\n\n.Technologies-card:nth-child(6) .Technologies-card-img img,\n.Technologies-card:nth-child(15) .Technologies-card-img img {\n  background-color: var(--reactnative-color);\n}\n\n.Technologies-card:nth-child(7) .Technologies-card-img img,\n.Technologies-card:nth-child(16) .Technologies-card-img img {\n  background-color: var(--javascript-color);\n}\n\n.Technologies-card:nth-child(8) .Technologies-card-img img,\n.Technologies-card:nth-child(17) .Technologies-card-img img {\n  background-color: var(--solidity-color);\n}\n\n.Technologies-card:nth-child(9) .Technologies-card-img img,\n.Technologies-card:nth-child(18) .Technologies-card-img img {\n  background-color: var(--ethereum-color);\n}\n\n.Technologies-card:hover .Technologies-card-img img {\n  transform: rotate(360deg);\n}\n\n.Technologies-card-title {\n  font-size: 1.2rem;\n  color: var(--primary-black2);\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .Technologies-card {\n    width: 200px;\n  }\n \n  .Technologies-title-box h1 {\n    font-size: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
